import React from 'react';
import Card, { CardContent } from '../components/ui/Card';
import Button from '../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const TestPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6 text-center">
          <CheckCircle className="h-12 w-12 text-green-600 mx-auto mb-4" />
          <h1 className="text-xl font-semibold mb-2">Test Page Works!</h1>
          <p className="text-neutral-600 mb-4">
            This confirms that React Router and basic page rendering is working correctly.
          </p>
          <div className="space-y-2">
            <Button onClick={() => navigate('/')} fullWidth>
              Go to Dashboard
            </Button>
            <Button variant="outline" onClick={() => navigate('/profile/complete')} fullWidth>
              Go to Profile Complete
            </Button>
            <Button variant="outline" onClick={() => navigate('/auth')} fullWidth>
              Go to Auth
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TestPage;